// Moon Yoga Fredericia - Robust Mock Data File
// Contains verbatim scraped content and clear internal placeholders for missing information.

export const siteBranding = {
  logo: "https://assets.auxodev.dk/assets/8bfce4c8-263d-41f5-85ff-0c7b7ca56872/moon-20yoga-20logo-300px.png",
  favicon: "https://assets.auxodev.dk/assets/8bfce4c8-263d-41f5-85ff-0c7b7ca56872/moon-yoga-300px-favikon.png",
  title: "Moon Yoga Fredericia",
  address: "Dalegade 61B, 7000 Fredericia",
  phone: "22 39 38 36",
  email: "Yoga@moonyoga-fredericia.dk",
  cvr: "46719395",
  facebook: "https://www.facebook.com/moonyogafredericia",
  instagram: "https://www.instagram.com/moonyoga_fredericia/"
};

export const navigationMenu = [
  { label: "House of Moon", href: "/" },
  { label: "Moon Team", href: "/instruktoerer" },
  { label: "Moon Gatherings", href: "/moon-gatherings" },
  { label: "Priser & vilkår", href: "/priser-vilkaar" },
  { label: "Holdplan", href: "/holdplan" }
];

export const forsideData = {
  // Slideshow images (using existing high-quality scraped images as fallback)
  slideshow: [
    {
      url: "https://assets.auxodev.dk/assets/8bfce4c8-263d-41f5-85ff-0c7b7ca56872/img-0038-enhanced-nr-red2.jpg",
      alt: "Moon Yoga forside - Nærværende yoga"
    },
    {
      url: "https://assets.auxodev.dk/assets/8bfce4c8-263d-41f5-85ff-0c7b7ca56872/img-0001.jpg",
      alt: "Moon Yoga forside - Find roen i kroppen"
    },
    {
      url: "https://assets.auxodev.dk/assets/8bfce4c8-263d-41f5-85ff-0c7b7ca56872/img-0043_5.jpg",
      alt: "Moon Yoga forside - Fællesskab og ro"
    },
    {
      url: "https://assets.auxodev.dk/assets/8bfce4c8-263d-41f5-85ff-0c7b7ca56872/img-0053.jpg",
      alt: "Moon Yoga forside - Fordybelse og balance"
    },
    {
      url: "https://assets.auxodev.dk/assets/8bfce4c8-263d-41f5-85ff-0c7b7ca56872/img-0097-enhanced-nr.jpg",
      alt: "Moon Yoga forside - Indre styrke og ro"
    },
    {
      url: "https://assets.auxodev.dk/assets/8bfce4c8-263d-41f5-85ff-0c7b7ca56872/img-0113_7.jpg",
      alt: "Moon Yoga forside - Bevægelse og flow"
    },
    {
      url: "https://assets.auxodev.dk/assets/8bfce4c8-263d-41f5-85ff-0c7b7ca56872/img-0135_7.jpg",
      alt: "Moon Yoga forside - Dit personlige frirum"
    }
  ],
  
  // Hero text section
  hero: {
    overtitle: "Velkommen til Moon Yoga",
    title: "Moon Yoga Fredericia",
    placeholderText: "",
    fallbackIntro: "Et helle i takt med livets rytmer."
  },

  // Verbatim intro text from "Hjem" and "Om Moon Yoga" (avoiding duplicates)
  intro: {
    title: "Velkommen til Moon Yoga",
    paragraphs: [
      "Moon Yoga er skabt som et pusterum i en verden, der sjældent står stille.",
      "Et sted, hvor du bliver holdt – så du kan give slip på hverdagens krav, sænke tempoet og blot være. Et sted, hvor du ikke behøver at være noget for nogen.",
      "Vi tror ikke på, at velvære og omsorg for sig selv er noget, man skal gøre sig fortjent til. Tværtimod.",
      "Vi ved, at det er essentielt for at kunne leve et liv i balance. For når vi passer på os selv, får vi mere overskud til alt det, der betyder noget. Derfor er egenomsorg ikke en luksus. Det er en nødvendighed.",
      "Moon Yoga er skabt med intentionen om at være et sted, hvor mennesker bliver holdt. Hvor yoga, meditation, ceremonier, behandlinger og små hverdagsritualer smelter sammen for at nære kroppen og berolige nervesystemet. Et sted, hvor du ikke behøver at gøre dig fortjent til ro. Et sted, hvor der er plads til både de lyse og de mørke dage. Hvor du bliver mødt med omsorg – præcis som du er.",
      "Vores hold spænder fra blide meditative sessioner til styrkende yoga og pulstræning. Nogle dage kalder kroppen på stilhed. Andre dage på bevægelse. Begge dele er lige værdifulde. Hos os handler det ikke om at præstere, men om at møde dig selv præcis dér, hvor du er.",
      "Navnet Moon Yoga er inspireret af månen, som minder os om, at vi ikke er skabt til at være de samme hver dag. Ligesom månen bevæger sig gennem sine faser, gør vi mennesker det også. Der er tid til at vokse, skabe og handle. Tid til at give slip, hvile og finde ny energi. Vi tror ikke på, at vi skal præstere hele tiden. Vi ved, at livet får mere værdi, når vi tør ære vores egen rytme.",
      "Den tanke lever i alt, hvad vi skaber.",
      "Fra den rolige atmosfære og de levende lys til den økologiske te, de friske råvarer, de sanselige detaljer og de små ritualer, der gør hvert besøg til en oplevelse. Vi ønsker, at du føler dig set. Holdt. Passet på. Ikke kun mens du er her – men også længe efter, du er gået ud ad døren.",
      "Vi håber, at Moon Yoga bliver et sted, du vender tilbage til. Ikke fordi du føler, du burde, men fordi du kan mærke forskel, når du har været her. Du har fundet ro. Styrke. Nærvær. Fællesskab. Og plads til bare at være.",
      "Velkommen til Moon Yoga.",
      "Et helle i takt med livets rytmer."
    ]
  },

  // Yoga, Styrke og Mindset section
  threePoints: [
    {
      id: "yoga",
      title: "YOGA",
      subtitle: "Styrke, fleksibilitet og bevægelse i balance.",
      icon: "fa-light fa-spa"
    },
    {
      id: "styrke",
      title: "STYRKE",
      subtitle: "Ægte styrke begynder med indre ro.",
      icon: "fa-light fa-dumbbell"
    },
    {
      id: "mindset",
      title: "MINDSET",
      subtitle: "Et rum fyldt med nærvær og omsorg.",
      icon: "fa-light fa-brain"
    }
  ]
};

export const instruktørData = {
  title: "Vores Instruktører",
  intro: "Mød underviserne hos Moon Yoga. Vi skaber et trygt, hjertevarmt og nærværende rum for din praksis.",
  list: [
    {
      id: "jozee",
      name: "Jozee",
      role: "Ejer & instruktør",
      image: "https://assets.auxodev.dk/assets/8bfce4c8-263d-41f5-85ff-0c7b7ca56872/img-0049-red.png",
      fallbackBio: "Jeg tror på, at vi alle bærer den ro, styrke og visdom, vi søger, allerede inden i os. Nogle gange har vi blot brug for et rum, hvor vi kan sænke tempoet, lytte indad og finde hjem til os selv igen.\n\nYoga blev for mig begyndelsen på netop den rejse.\n\nDet, der startede som en nysgerrighed på kroppens bevægelser, udviklede sig hurtigt til en livslang passion for mennesket som en helhed. Gennem de sidste 10 år har jeg dedikeret mig til at forstå kroppens anatomi og samspillet mellem styrke, mobilitet, fleksibilitet og restitution. Min undervisning bygger på en dyb respekt for kroppen og dens intelligens – ikke på præstation, men på bevidsthed.\n\nJeg tog min primære yogalæreruddannelse hos <strong>House of Om på Bali</strong>, hvor yogaens filosofi og spirituelle tradition blev en naturlig del af min egen praksis. Senere specialiserede jeg mig i <strong>Yin Yoga hos YogaUnion</strong>, og jeg er desuden certificeret i cupping, hvilket har givet mig en endnu større forståelse for kroppens bindevæv, energibaner og evne til at hele.\n\nJeg brænder også dybt for de behandlinger, vi tilbyder i studiet – særligt behandlinger med cupping og vores RollShaper. For mig er det en forlængelse af yogaens univers, hvor vi arbejder med kroppen på en mere målrettet og sanselig måde. Jeg elsker at introducere mennesker til disse behandlinger og vise, hvordan de kan støtte kroppens flow, frigøre spændinger og skabe en følelse af lethed og velvære.\n\nFor mig er yoga langt mere end asanas.\n\nMeditation er lige så vigtig som bevægelse. Stilheden mellem åndedragene kan ofte lære os mere end de mest avancerede yogastillinger. Jeg tror også på, at vores energi formes af det, vi omgiver os med – den mad vi spiser, de ord vi lytter til, de mennesker vi deler vores liv med, og de tanker vi vælger at give næring.\n\nAlt hænger sammen.\n\nNår vi skaber balance i én del af livet, begynder resten stille og roligt at følge med.\n\nDet største privilegium i mit arbejde er at få lov til at holde rum for andre mennesker. At se skuldre sænke sig. At mærke et menneske finde tilbage til sit åndedræt. At opleve, hvordan kroppen åbner sig, når sindet får lov til at falde til ro.\n\nMit ønske er ikke blot at undervise yoga, men at skabe en oplevelse, hvor du føler dig set, mødt og støttet. Et sted, hvor du kan give slip på hverdagens støj og genfinde forbindelsen til den, du allerede er.\n\nFor mig er det essensen af Moon Yoga – et rum, hvor krop, sind og sjæl mødes i ro, nærvær og autenticitet."
    },
    {
      id: "camilla",
      name: "Camilla",
      role: "Ejer & instruktør",
      image: "https://assets.auxodev.dk/assets/8bfce4c8-263d-41f5-85ff-0c7b7ca56872/3069.jpg",
      fallbackBio: "Camilla er uddannet yogalærer med mere end 500 timers uddannelse og har specialiseret sig i Kundalini Yoga og Pranayama.\n\nCamilla praktiserer selv hver eneste dag og for hende er Kundalini Yoga – og yoga generelt – langt mere end tiden på måtten. Det er en livsstil og en måde at møde både sig selv og verden på.\n\nHun tror ikke, at hendes rolle, som underviser, er at vise dig vejen og hun tror heller ikke på, at du skal blive en ny version af dig selv. Hun ønsker at støtte dig i at have tillid til den vej, der allerede lever i dig og modet til at huske den, du altid har været.\n\nI hendes undervisning bliver du mødt med nærvær, varme og plads til at gå i dybden. Hun sætter en ære i at skabe et trygt rum, hvor du kan styrke forbindelsen til din intuition, genfinde tilliden til det, som du allerede ved og få modet til at leve med hjertet som kompas.\n\nFor Camilla handler yoga ikke om at blive et bedre menneske, men om at huske den, du allerede er. Når forbindelsen til din sjæl bliver stærkere, følger friheden, autenticiteten og modet til at udleve det, som du drømmer om.\n\nHvis du længes efter mere dybde, mere autenticitet, mere frihed og en stærkere forbindelse til dig selv, glæder Camilla sig til at byde dig velkommen på måtten."
    }
  ]
};

export const moonGatheringsData = {
  title: "Måneceremoni 🌙",
  intro: "Månen har gennem tusindvis af år været et symbol på, at livet bevæger sig i cyklusser.\nDen minder os om, at der er tider til at skabe, tider til at give slip, tider til handling og tider til hvile.\nTil vores måneceremonier skaber vi et trygt og nærværende rum, så du kan sænke tempoet, tune ind og lade dig inspirere af den kommende månes temaer.\nGennem astrologi, ceremoniel kakao, kundalini og fællesskab inviteres du ikke blot til at forstå månens temaer, men til at mærke dem og leve mere bevidst i takt med månens rytme.",
  
  elementsTitle: "Ceremoniens elementer",
  elements: [
    {
      icon: "🤎",
      title: "Ceremoniel kakao",
      description: "Vi starter ceremonien med en kop ceremoniel kakao, som inviterer til nærvær, ro og en blid åbning af hjertet. En smuk overgang fra hverdagens høje tempo til et rum med nærvær, intention og fordybelse."
    },
    {
      icon: "🪷",
      title: "Kundalini meditation",
      description: "En meditationspraksis, som hjælper med at stilne sindet, skabe indre ro og styrke intuitionen, så du er nærværende og klar til at modtage med et åbent hjerte."
    },
    {
      icon: "🌙",
      title: "Astro Talk",
      description: "Du introduceres til astrologien bag den kommende måne. Vi dykker ned i månens temaer, energier og invitationer, så du får en dybere forståelse af, hvordan du bevidst kan arbejde med den kommende månecyklus."
    },
    {
      icon: "✨",
      title: "Kundalini praksis",
      description: "Vi fordyber os i en kundalini-praksis, der er sammensat til den aktuelle månes energi, så astrologien ikke blot bliver en indsigt, men en oplevelse, du mærker og integrerer gennem kroppen, åndedrættet og bevidstheden."
    },
    {
      icon: "🤍",
      title: "Deling og afrunding",
      description: "Vi afslutter ceremonien i fællesskab med plads til refleksion og delinger."
    }
  ],

  finalDescription: "Ceremonierne er hver især en komplet oplevelse, og du kan sagtens deltage i en enkelt eller to, hvis du er nysgerrig, eller hvis det er det, der giver mening for dig lige nu.\n\nSamtidig oplever mange, at den største gave ligger i at følge månens cyklus over tid. Når du vender tilbage måned efter måned, begynder du at mærke naturens rytme i dig. Astrologiens temaer bliver mere levende, din praksis bliver dybere, og du skaber et tilbagevendende rum for refleksion, udvikling og nærvær.\n\nMåneceremonierne bliver på den måde ikke blot enkeltstående oplevelser, men små pejlemærker gennem året, som inviterer dig til at leve mere bevidst og i tættere forbindelse med dig selv og månens cyklus.",

  prices: [
    { name: "Enkelt ceremoni", price: "333 kr." },
    { name: "Ceremonipakke (5 ceremonier)", price: "1.333 kr." }
  ],

  ceremonies: [
    {
      day: "Onsdag",
      date: "12. august 2026",
      time: "17.00–19.00",
      title: "Nymåneceremoni",
      type: "nymane",
      link: "https://moonyoga.yogo.dk/frontend/index.html?itemType=event&itemId=27573#/login-with-cart"
    },
    {
      day: "Fredag",
      date: "11. september 2026",
      time: "17.00–19.00",
      title: "Nymåneceremoni",
      type: "nymane",
      link: "https://moonyoga.yogo.dk/frontend/index.html?itemType=event&itemId=27574#/login-with-cart"
    },
    {
      day: "Søndag",
      date: "27. september 2026",
      time: "16.00–18.00",
      title: "Fuldmåneceremoni",
      type: "fuldmane",
      link: "https://moonyoga.yogo.dk/frontend/index.html?itemType=event&itemId=27606#/login-with-cart"
    },
    {
      day: "Fredag",
      date: "9. oktober 2026",
      time: "17.00–19.00",
      title: "Nymåneceremoni",
      type: "nymane",
      link: "https://moonyoga.yogo.dk/frontend/index.html?itemType=event&itemId=27603#/login-with-cart"
    },
    {
      day: "Søndag",
      date: "25. oktober 2026",
      time: "16.00–18.00",
      title: "Fuldmåneceremoni",
      type: "fuldmane",
      link: "https://moonyoga.yogo.dk/frontend/index.html?itemType=event&itemId=27607#/login-with-cart"
    },
    {
      day: "Søndag",
      date: "8. november 2026",
      time: "16.00–18.00",
      title: "Nymåneceremoni",
      type: "nymane",
      link: "https://moonyoga.yogo.dk/frontend/index.html?itemType=event&itemId=27604#/login-with-cart"
    },
    {
      day: "Tirsdag",
      date: "24. november 2026",
      time: "17.00–19.00",
      title: "Fuldmåneceremoni",
      type: "fuldmane",
      link: "https://moonyoga.yogo.dk/frontend/index.html?itemType=event&itemId=27608#/login-with-cart"
    },
    {
      day: "Onsdag",
      date: "9. december 2026",
      time: "17.00–19.00",
      title: "Nymåneceremoni",
      type: "nymane",
      link: "https://moonyoga.yogo.dk/frontend/index.html?itemType=event&itemId=27605#/login-with-cart"
    }
  ],
  notice: "Nye Moon Gatherings offentliggøres løbende. Hold øje med siden her eller vores sociale medier.",

  otherEventsTitle: "Andre Events",
  otherEventsIntro: "Udover vores måneceremonier afholder vi løbende fordybende workshops, retreats og unikke oplevelser.",
  otherEvents: [
    {
      id: "gua-sha-godess",
      title: "Gua Sha Godess event",
      notice: "Der gives 1 goodiebag pr. deltager - ikke pr. dag ;) <3\nSe programmet under hver enkelt dag <3",
      days: [
        {
          dayNumber: 1,
          date: "September 2026",
          startTime: "18:00",
          endTime: "21:15",
          title: "Dag 1: Gua Sha Godess aften - med Claire The Ritual Woman",
          intro: "Vi åbner retreatet med en varm og hjerteåbnende ceremoni med kakao, der skaber et nærværende rum for fordybelse og intention.",
          programTitle: "Program (vejledende da vi altid arbejde intuitivt med energierne på dagen)",
          programItems: [
            "Velkomst med ceremoniel kakao",
            "Meditation",
            "Åndedrætsøvelser (breathwork)",
            "Reflekterende skriveøvelser",
            "Gua sha til stimulering af lymfesystemet",
            "Afslutning med Empowerment Breath"
          ],
          outro: "Farvel og tak for i dag + Goodiebag <3",
          link: "https://moonyoga.yogo.dk/frontend/index.html?itemType=event&itemId=26392#/login-with-cart"
        },
        {
          dayNumber: 2,
          date: "September 2026",
          startTime: "10:00",
          endTime: "14:00",
          title: "Dag 2: Gua Sha Godess dag - med Claire The Ritual Woman",
          intro: "En dag dedikeret til manifestation, skønhed og selvomsorg, hvor vi kombinerer viden, praksis og nærende ritualer.",
          programTitle: "Program (vejledende da vi altid arbejde intuitivt med energierne på dagen)",
          programItems: [
            "Velkomst med blå lotus-te",
            "Manifesterende skriveøvelser",
            "Introduktion til lymfesystemet og krystallers energi",
            "Ansigts-gua sha",
            "Frokostpause med oplæg fra Claire om betydningen af en sund og varieret kost",
            "Ceremoniel kakao",
            "Yin yoga med gua sha",
            "Afslutning med Beauty Breath"
          ],
          outro: "Tak for i dag + Goodiebag <3",
          link: "https://moonyoga.yogo.dk/frontend/index.html?itemType=event&itemId=26393#/login-with-cart"
        },
        {
          dayNumber: 3,
          date: "September 2026",
          startTime: "10:00",
          endTime: "14:00",
          title: "Dag 3: Gua Sha Godess dag - med Claire The Ritual Woman",
          intro: "Vi afrunder weekenden med blid bevægelse, dyb afspænding og helende ritualer, der støtter både krop og sind.",
          programTitle: "Program (vejledende da vi altid arbejde intuitivt med energierne på dagen)",
          programItems: [
            "Velkomst med jasmin-te",
            "Yin yoga, breathwork og en kort Yoga Nidra",
            "Ansigts-gua sha",
            "Frokostpause",
            "Ceremoniel kakao",
            "Gua sha for hele kroppen med fokus på lymfesystemet",
            "Fælles afslutning"
          ],
          outro: "Tak for denne weekend + Goodiebag <3",
          link: "https://moonyoga.yogo.dk/frontend/index.html?itemType=event&itemId=26394#/login-with-cart"
        }
      ],
      link: "https://moonyoga.yogo.dk/frontend/index.html?itemType=event&itemId=26546#/login-with-cart"
    }
  ]
};

// Helper function to calculate price without VAT (divided by 1.25)
const calcNoVat = (price) => {
  const calculated = price / 1.25;
  // Round to nearest integer or 1 decimal place for clean Danish formatting
  return Math.round(calculated);
};

export const priserData = {
  title: "Priser & vilkår",
  intro: "Hos Moon Yoga ønsker vi at skabe en klar og enkel ramme for din praksis. Derfor tilbyder vi udelukkende faste medlemskaber (abonnementer) til vores hold, så du kan skabe en regelmæssig rutine, samt dybdegående behandlinger.",
  
  // Exactly 4 columns required for desktop layout
  memberships: [
    {
      name: "Nymåne",
      tag: "Et blidt sted at starte",
      description: "Et blidt sted at starte.\n\nNymåne er til dig, der ønsker en fast yogapraksis med plads til fleksibilitet.\n\nForkæl dig selv med 4 hold om måneden, så du kan fordybe dig, når det kalder.",
      priceOver30: 248,
      priceUnder30: calcNoVat(248),
      interval: "pr. måned",
      oprettelse: "Oprettelsesgebyr: 128,00 kr.",
      features: [
        "4 hold om måneden",
        "Frisk frugt, nødder, the og vand"
      ],
      buttonText: "Køb medlemskab",
      link: "https://moonyoga.yogo.dk/frontend/index.html#/"
    },
    {
      name: "Halvmåne",
      tag: "Dedikeret praksis",
      description: "Halvmåne er til dig, der ønsker en mere dedikeret yogapraksis med friheden til at deltage på op til 8 hold om måneden.",
      priceOver30: 448,
      priceUnder30: calcNoVat(448),
      interval: "pr. måned",
      oprettelse: "Oprettelsesgebyr: 128,00 kr.",
      features: [
        "8 hold om måneden",
        "Frisk frugt, nødder, the og vand"
      ],
      buttonText: "Køb medlemskab",
      link: "https://moonyoga.yogo.dk/frontend/index.html#/"
    },
    {
      name: "Fuldmåne",
      tag: "Ubegrænset & Velvære",
      description: "Fuldmåne-medlemskabet er til dig, der ikke ønsker begrænsninger på din praksis og samtidig forkæle dig selv med lidt ekstra velvære.\n\nMed Fuldmåne får du ubegrænset holdtræning samt dit første valgfrie event og 30 min. behandling inkluderet – efterfølgende får du 25% rabat på Moon Yogas events og behandlinger.",
      priceOver30: 848,
      priceUnder30: calcNoVat(848),
      interval: "pr. måned",
      oprettelse: "Oprettelsesgebyr: 128,00 kr.",
      features: [
        "Ubegrænset holdtræning",
        "Første event uden beregning",
        "Første (30 min.) behandling uden beregning",
        "25% rabat på øvrige events og behandlinger",
        "Frisk frugt, nødder, the og vand"
      ],
      buttonText: "Køb medlemskab",
      link: "https://moonyoga.yogo.dk/frontend/index.html#/"
    },
    {
      name: "Supermåne",
      tag: "Vores mest eksklusive",
      description: "Vores mest eksklusive medlemskab.\n\nSupermåne er til dig, der ønsker det hele. Forkæl dig selv med ubegrænset holdtræning, deltag i et valgfrit event hver måned, og nyd en 30 min. behandling hver måned.\n\nDerudover får du 50 % rabat på alle øvrige events og behandlinger.",
      priceOver30: 1248,
      priceUnder30: calcNoVat(1248),
      interval: "pr. måned",
      oprettelse: "Oprettelsesgebyr: 128,00 kr.",
      features: [
        "Ubegrænset holdtræning",
        "1 x event om måneden",
        "1 x 30 min. behandling om måneden",
        "50 % rabat på øvrige events og behandlinger",
        "Frisk frugt, nødder, the og vand"
      ],
      buttonText: "Køb medlemskab",
      link: "https://moonyoga.yogo.dk/frontend/index.html#/"
    }
  ],

  // Other prices (Treatments and treatment punch cards)
  otherPrices: [
    {
      category: "Behandlinger & Klippekort",
      items: [
        { name: "1 x cupping/roll shaper 30 min", price: "398,-", desc: "30 min. cupping eller roll shaper behandling" },
        { name: "5 x cupping/roll shaper 30 min", price: "1598,-", desc: "Klippekort til 5 x 30 min. cupping eller roll shaper" },
        { name: "1 x 60 min roll shaper", price: "598,-", desc: "60 min. roll shaper behandling" },
        { name: "5 x 60 min roll shaper", price: "2798,-", desc: "Klippekort til 5 x 60 min. roll shaper" }
      ]
    }
  ],

  // 1:1 med Jozee
  jozee1on1: {
    title: "1:1 med Jozee",
    subtitle: "Styrke, bevægelse og balance i krop og sind",
    description: "En stærk krop begynder med et roligt sind. Når vi finder mere ro og nærvær, skaber vi samtidig de bedste forudsætninger for, at kroppen kan udvikle sig, hele og blive stærkere.\n\nHos Jozee får du et personligt yogaforløb med fokus på styrke, fleksibilitet, mobilitet og kropsbevidsthed – altid tilpasset dine behov og mål.\n\nGennem målrettet yoga, åndedræt og nærvær arbejder vi med hele mennesket, fordi krop og sind er uløseligt forbundet.\n\nUanset om du ønsker at blive stærkere, mere smidig, mindske smerter eller skabe større balance i livet, møder du et trygt rum med plads til udvikling – både fysisk og mentalt.",
    prices: [
      { option: "Enkelt session", price: "600 kr. pr. time" },
      { option: "Forløb (5 sessioner)", price: "5 sessioner for 2.500 kr." }
    ],
    link: "https://moonyoga.yogo.dk/frontend/index.html#/"
  },

  // Udlejning af lokaler
  lokaleudlejning: {
    title: "Udlejning af lokaler",
    description: "Er du behandler, coach, underviser eller terapeut og søger smukke, rolige rammer til din virksomhed?\n\nHos Moon Yoga udlejer vi lyse og stemningsfulde lokaler i hjertet af Fredericia – ideelle til behandlinger, samtaler, undervisning, workshops og mindre arrangementer.\n\nStudiet er indrettet med fokus på nærvær, æstetik og velvære, så både du og dine klienter får en rolig og indbydende oplevelse.",
    price: "Leje fra 150 kr. pr. time ekskl. moms.",
    finalText: "Kontakt os gerne for at høre mere om muligheder, priser og ledige tider.",
    contactEmail: "yoga@moonyoga-fredericia.dk"
  },

  // Vilkår section (Udfyldt ud fra Tilmeldingsbetingelser & Handelsbetingelser)
  terms: [
    {
      title: "Booking & Venteliste",
      content: "Booking foregår via YOGO inden for den til enhver tid gældende bookingperiode. Du kan booke hold eller behandlinger, hvis du har et aktivt medlemskab, et gyldigt klippekort eller en Moon Experience.\n\nHvis et hold er fuldt booket, kan du skrive dig på venteliste. Ventelisten slettes 4 timer før holdstart. Bliver der ledige pladser herefter, kan de bookes efter først til mølle-princippet."
    },
    {
      title: "Afmelding, No-show & Gebyrer",
      content: "Holdtræning: Afmelding skal ske senest 4 timer før holdstart. Ved manglende eller for sen afmelding opkræves et no-show-gebyr på 48 kr. for medlemmer. Ved Moon Experience betragtes oplevelsen som anvendt.\n\nMoon Treatments: Afmelding skal ske senest 24 timer før behandlingen. Ved udeblivelse eller afmelding senere end 24 timer opkræves det fulde beløb.\n\nMoon Gatherings: Tilmelding er bindende og kan ikke afbestilles, men du er velkommen til at overdrage din plads til en anden (Moon Yoga skal informeres om navneændring inden start)."
    },
    {
      title: "Betaling, Opsigelse & Pause",
      content: "Første betaling trækkes ved oprettelse. Herefter trækkes betalingen automatisk på den aftalte betalingsdato hver måned.\n\nOpsigelse: Medlemskabet kan opsiges via YOGO eller skriftligt til Moon Yoga. Opsigelsesvarslet er løbende måned plus én måned.\n\nPause: Et medlemskab kan sættes på pause én gang pr. kalenderår i op til 90 dage uden beregning (planlægges op til 30 dage frem)."
    },
    {
      title: "Aflysninger fra Moon Yogas side",
      content: "Holdtræning kan aflyses ved færre end 2 tilmeldte senest 2 timer før holdstart. Moon Gatherings kan aflyses ved færre end 4 tilmeldte senest 48 timer før start. Ved aflysning tilbydes fuld refundering eller et tilgodebevis."
    },
    {
      title: "Misbrug & Studieetik",
      content: "Medlemskabet er personligt og må ikke overdrages. Væsentligt misbrug eller gentagne overtrædelser af vores medlemsvilkår og studieetik kan medføre opsigelse af medlemskabet uden varsel."
    },
    {
      title: "Gavekort & Fysiske produkter",
      content: "Gavekort er gyldige i 730 dage fra købsdatoen og kan anvendes til ydelser i YOGO. Ved køb af fysiske produkter i webshoppen gælder 14 dages lovpligtig fortrydelsesret."
    }
  ]
};

export const holdplanData = {
  title: "Holdplan",
  intro: "Holdene er skabt, så du kan møde op, som du er, og få en praksis, der giver dig fornyet energi, ro og balance. Nogle vælger yoga som et fast anker i ugen, andre bruger det som en selvforkælelse, når behovet melder sig.",
  description: "Vi lægger vægt på at holde vores klasser nærværende, rolige og åbne for alle niveauer. Det vigtigste er ikke, hvor smidig du er, men at du møder dig selv dér, hvor du er, med kærlighed og accept.\n\nHoldplanen ændrer sig løbende i takt med årstiderne og fællesskabets behov. Kig forbi, vælg din vej, og find det, der bringer dig mest balance og velvære.",
  
  // YOGO integration info
  yogo: {
    calendarClass: "yogo-calendar",
    loginUrl: "https://moonyoga.yogo.dk/frontend/index.html#/my-profile"
  },

  practicalInfo: [
    {
      title: "Mød op i god tid",
      text: "Kom gerne 5-10 minutter før klassen starter, så du kan lande roligt på måtten og finde din plads uden stress."
    },
    {
      title: "Udstyr i studiet",
      text: "Vi har måtter, tæpper og blokke til rådighed i studiet, men du er også altid velkommen til at medbringe dit eget udstyr, hvis du foretrækker det."
    },
    {
      title: "Beklædning",
      text: "Bær behageligt tøj, som du kan bevæge dig frit i. Vi dyrker yoga i bare tæer eller strømper."
    }
  ]
};
